import { Link } from "react-router-dom";
import { ArrowUpRight, Instagram, MessageCircle } from "lucide-react";
import { YMark } from "./Logo";

const Mail = ({ email, id }) => (
  <a data-testid={id} href={`mailto:${email}`} className="block break-all text-base underline-offset-4 hover:underline">{email}</a>
);

const Block = ({ title, children }) => (
  <div>
    <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#1c1418]/60">{title}</p>
    <div className="mt-3 space-y-3">{children}</div>
  </div>
);

const Person = ({ name, email, id }) => (
  <div>
    <p className="font-display text-2xl uppercase leading-none">{name}</p>
    <Mail email={email} id={id} />
  </div>
);

export const Footer = () => (
  <footer id="contact" data-testid="site-footer" className="relative overflow-hidden bg-white border-t border-[#1c1418]/15 text-[#1c1418]">
    <div className="mx-auto max-w-[1400px] px-5 pb-10 pt-24 md:px-10">
      <div className="grid gap-12 border-b border-[#1c1418]/15 pb-16 md:grid-cols-12">
        <div className="md:col-span-5">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#1c1418]">Contact</p>
          <h3 className="mt-4 font-display text-5xl uppercase leading-[0.9] md:text-6xl">Let's talk<span className="text-[#1c1418]">.</span></h3>
          <p className="mt-6 max-w-sm font-serif text-xl italic text-[#1c1418]/75">Bookings, castings and new faces — Milano.</p>
        </div>
        <div className="grid gap-8 sm:grid-cols-2 md:col-span-7">
          <Block title="Booker">
            <Person name="Gergana Dimitrova" email="gergana@youthmanagement.com" id="footer-booker-gergana" />
            <Person name="Marco La Sorte" email="marco@youthmanagement.com" id="footer-booker-marco" />
          </Block>
          <Block title="Scouting">
            <p data-testid="footer-scouting-team" className="font-display text-2xl uppercase leading-tight">Rebecca Klimova<br />Giulia Zaffaroni<br />Valeria Viola</p>
            <Mail email="scouting@youthmanagement.com" id="footer-scout-email" />
          </Block>
          <Block title="General inquiries">
            <Mail email="info@youthmanagement.com" id="footer-info-email" />
          </Block>
          <Block title="Financial">
            <Mail email="financial@youthmanagement.com" id="footer-financial-email" />
          </Block>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#1c1418]/60">Office</p>
            <p data-testid="footer-address" className="mt-3 text-lg">Via Tortona 16<br />20144 Milano</p>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#1c1418]/60">WhatsApp</p>
            <a data-testid="footer-whatsapp" href="https://wa.me/393341726456" target="_blank" rel="noopener noreferrer"
              className="mt-3 flex items-center gap-2 text-lg hover:underline">
              <MessageCircle className="h-5 w-5 text-[#e9458f]" /> +39 3341726456
            </a>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#1c1418]/60">Instagram</p>
            <a data-testid="footer-instagram" href="https://www.instagram.com/youth_mgmt/" target="_blank" rel="noopener noreferrer"
              className="mt-3 flex items-center gap-2 text-lg hover:underline">
              <Instagram className="h-5 w-5 text-[#e9458f]" /> @youth_mgmt
            </a>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-start justify-between gap-6 pt-10 md:flex-row md:items-end">
        <div className="flex items-end gap-4">
          <YMark className="h-20 w-20 md:h-28 md:w-28" />
          <span className="font-display text-[18vw] uppercase leading-[0.8] tracking-tight md:text-[11rem]">Youth</span>
        </div>
        <div className="flex flex-col gap-3 font-mono text-[11px] uppercase tracking-[0.25em] text-[#1c1418]/60 md:items-end">
          <Link to="/apply" data-testid="footer-apply-link" className="flex items-center gap-2 text-[#1c1418]">Youth is yours <ArrowUpRight className="h-4 w-4 text-[#e9458f]" /></Link>
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-[#1c1418]">Staff area</Link>
          <span>© {new Date().getFullYear()} Youth Management Milano</span>
        </div>
      </div>
    </div>
  </footer>
);
